/**
 * 指定された日付文字列を "YYYY.MM.DD" 形式に変換する
 *
 * @param {string} date - 変換する日付文字列。ISO 8601形式（例: "2023-10-05"）を推奨
 * @returns {string} "YYYY.MM.DD" 形式の日付文字列。
 *
 * @example
 * // 例: "2023-10-05" を "2023.10.05" に変換
 * const formattedDate = convertYYYYMMDD("2023-10-05");
 * console.log(formattedDate); // 出力: "2023.10.05"
 *
 * @todo {@link https://github.com/sozo-japan/corporate/issues/21}
 */
export const convertYYYYMMDD = (date: string) => {
  const newDate: Date = new Date(date)

  const year: number = newDate.getUTCFullYear()
  const month: string = ('0' + (newDate.getUTCMonth() + 1)).slice(-2) // Months are zero-based
  const day: string = ('0' + newDate.getUTCDate()).slice(-2)

  return `${year}/${month}/${day}`
}
